import React from 'react';
import {
    X,
    User,
    Activity,
    ArrowUpRight,
    ArrowDownRight,
    ArrowDownLeft,
    Plus,
    Package,
    CreditCard
} from 'lucide-react';
import { displayUpperCase } from '../../utils/textUtils';

const DashboardModals = ({
    showActiveCustomersModal,
    setShowActiveCustomersModal,
    showCashFlowModal,
    setShowCashFlowModal,
    dashboardData,
    getDateRangeText,
    showProfitModal,
    setShowProfitModal,
    showExpenseListModal,
    setShowExpenseListModal,
    showSoldQuantityModal,
    setShowSoldQuantityModal,
    soldProducts,
    loadingSoldProducts,
    showCarSoldQuantityModal,
    setShowCarSoldQuantityModal,
    carSoldProducts,
    loadingCarSoldProducts,
    getTotalAmount,
    showServiceDataModal,
    setShowServiceDataModal,
    serviceFormDraft,
    setServiceFormDraft,
    serviceFormRemoved,
    setServiceFormRemoved,
    serviceFormDirty,
    setServiceFormDirty,
    savingServiceForm,
    setSavingServiceForm,
    addServiceDraftItem,
    removeServiceDraftItem,
    handleServiceDraftChange,
    handleSaveServiceData,
    showCashIncomeModal,
    setShowCashIncomeModal,
    cashIncomeDraft,
    setCashIncomeDraft,
    cashIncomeRemoved,
    setCashIncomeRemoved,
    cashIncomeDirty,
    setCashIncomeDirty,
    savingCashIncome,
    setSavingCashIncome,
    cashIncomeModalLoading,
    addCashIncomeDraft,
    removeCashIncomeDraft,
    handleCashIncomeDraftChange,
    handleSaveCashIncome,
    cashExpenseDraft,
    setCashExpenseDraft,
    cashExpenseRemoved,
    setCashExpenseRemoved,
    cashExpenseDirty,
    setCashExpenseDirty,
    savingCashExpenses,
    setSavingCashExpenses,
    addCashExpenseDraft,
    removeCashExpenseDraft,
    handleCashExpenseDraftChange,
    handleSaveCashExpenses
}) => {
    return (
        <>
            {/* Active Customers Modal */}
            {showActiveCustomersModal && (
                <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
                        <div className="px-6 py-4 border-b border-gray-200 bg-white">
                            <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
                                <div>
                                    <h2 className="text-2xl font-semibold text-gray-900 flex items-center gap-3">
                                        <User className="w-7 h-7 text-blue-600" />
                                        Müşteri Ödemeleri
                                    </h2>
                                    <p className="text-sm text-gray-500 mt-1">
                                        Müşterilerden alınan bakiye tutarları ve detayları
                                    </p>
                                </div>
                                <div className="flex items-center gap-2">
                                    <button
                                        onClick={() => setShowActiveCustomersModal(false)}
                                        className="text-gray-400 hover:text-gray-600 transition-colors"
                                    >
                                        <X className="w-6 h-6" />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="flex-1 overflow-y-auto bg-gray-50">
                            {(dashboardData.dailyCashFlow?.transactions || []).length === 0 ? (
                                <div className="flex h-full items-center justify-center">
                                    <div className="text-center py-12 text-gray-500">
                                        <CreditCard className="h-16 w-16 mx-auto mb-4 text-gray-300" />
                                        <p className="text-lg font-medium">Müşteri ödemesi bulunamadı</p>
                                        <p className="text-sm mt-1">Bu dönemde müşteri ödemesi bulunmamaktadır.</p>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className="overflow-x-auto">
                                        <table className="min-w-full divide-y divide-gray-200">
                                            <thead className="bg-gray-100">
                                                <tr>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Müşteri
                                                    </th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Telefon
                                                    </th>
                                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Tutar
                                                    </th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Ödeme Tarihi
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                                {dashboardData.dailyCashFlow.transactions.map((transaction, index) => (
                                                    <tr key={index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <div className="text-sm font-medium text-gray-900">
                                                                {displayUpperCase(transaction.customerName || 'Bilinmeyen Müşteri')}
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <div className="text-sm text-gray-600">
                                                                {transaction.phone || '-'}
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-right">
                                                            <div className="text-sm font-bold text-green-600">
                                                                {Number(transaction.amount || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <div className="text-sm text-gray-600">
                                                                {new Date(transaction.date).toLocaleDateString('tr-TR')}
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className="p-6 bg-white border-t border-gray-200">
                                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                                            <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                                                <div className="text-sm font-medium text-green-600 mb-1">Toplam Ödeme</div>
                                                <div className="text-2xl font-bold text-green-700">
                                                    {dashboardData.dailyCashFlow.transactions.reduce((sum, t) => sum + Number(t.amount || 0), 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                </div>
                                            </div>
                                            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                                <div className="text-sm font-medium text-blue-600 mb-1">Toplam İşlem</div>
                                                <div className="text-2xl font-bold text-blue-700">
                                                    {dashboardData.dailyCashFlow.transactions.length} adet
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Cash Flow Modal */}
            {showCashFlowModal && (
                <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 md:p-8">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
                        <div className="px-8 py-6 border-b border-gray-200 bg-white">
                            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                                <div>
                                    <h2 className="text-2xl font-semibold text-gray-900 flex items-center gap-3">
                                        <Activity className="w-7 h-7 text-blue-600" />
                                        Detaylı Nakit Akışı
                                    </h2>
                                    <p className="text-sm text-gray-500 mt-1">
                                        {getDateRangeText()} dönemine ait detaylı nakit akışı bilgileri.
                                    </p>
                                </div>
                                <button
                                    onClick={() => setShowCashFlowModal(false)}
                                    className="text-gray-400 hover:text-gray-600 transition-colors"
                                >
                                    <X className="w-6 h-6" />
                                </button>
                            </div>
                        </div>

                        <div className="flex-1 overflow-y-auto bg-gray-50 px-6 py-6">
                            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                                {/* Gelirler */}
                                <div className="space-y-4">
                                    <h3 className="text-lg font-semibold text-green-900">Gelirler</h3>
                                    <div className="space-y-3">
                                        <div className="p-4 bg-green-50 rounded-lg">
                                            <div className="text-center">
                                                <div className="text-3xl font-bold text-green-600">
                                                    {dashboardData.dailyCashFlow.income.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                </div>
                                                <div className="text-sm text-gray-600">Toplam Gelir</div>
                                            </div>
                                        </div>
                                        <div className="space-y-2">
                                            <div className="flex justify-between items-center p-3 bg-white rounded border">
                                                <span className="text-sm text-gray-600">Servis Geliri</span>
                                                <span className="font-semibold text-green-600">
                                                    {dashboardData.dailyCashFlow.serviceIncome?.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) || '0.00'} ₺
                                                </span>
                                            </div>
                                            <div className="flex justify-between items-center p-3 bg-white rounded border">
                                                <span className="text-sm text-gray-600">Satış Gelirleri</span>
                                                <span className="font-semibold text-green-600">
                                                    {dashboardData.dailyCashFlow.cashSalesIncome?.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) || '0.00'} ₺
                                                </span>
                                            </div>
                                            <div className="flex justify-between items-center p-3 bg-white rounded border">
                                                <span className="text-sm text-gray-600">Müşteri Ödemeleri</span>
                                                <span className="font-semibold text-green-600">
                                                    {dashboardData.dailyCashFlow.cashPaymentsIncome?.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) || '0.00'} ₺
                                                </span>
                                            </div>
                                            <div className="flex justify-between items-center p-3 bg-white rounded border">
                                                <span className="text-sm text-gray-600">Manuel Kasa Gelirleri</span>
                                                <span className="font-semibold text-green-600">
                                                    {dashboardData.dailyCashFlow.manualCashIncome?.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) || '0.00'} ₺
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* Giderler */}
                                <div className="space-y-4">
                                    <h3 className="text-lg font-semibold text-red-900">Giderler</h3>
                                    <div className="space-y-3">
                                        <div className="p-4 bg-red-50 rounded-lg">
                                            <div className="text-center">
                                                <div className="text-3xl font-bold text-red-600">
                                                    {dashboardData.dailyCashFlow.expenses.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                </div>
                                                <div className="text-sm text-gray-600">Toplam Gider</div>
                                            </div>
                                        </div>
                                        <div className="space-y-2">
                                            <div className="flex justify-between items-center p-3 bg-white rounded border">
                                                <span className="text-sm text-gray-600">Servis Gideri</span>
                                                <span className="font-semibold text-red-600">
                                                    -{dashboardData.dailyCashFlow.serviceExpenses?.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) || '0.00'} ₺
                                                </span>
                                            </div>
                                            <div className="flex justify-between items-center p-3 bg-white rounded border">
                                                <span className="text-sm text-gray-600">Diğer Kasa Giderleri</span>
                                                <span className="font-semibold text-red-600">
                                                    -{((dashboardData.dailyCashFlow.cashExpenses || 0) - (dashboardData.dailyCashFlow.manualCashExpenses || 0)).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                </span>
                                            </div>
                                            <div className="flex justify-between items-center p-3 bg-white rounded border">
                                                <span className="text-sm text-gray-600">Manuel Kasa Giderleri</span>
                                                <span className="font-semibold text-red-600">
                                                    -{dashboardData.dailyCashFlow.manualCashExpenses?.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) || '0.00'} ₺
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Net Akış */}
                            <div className="mt-6 p-6 bg-gray-50 rounded-lg border-2 border-gray-300">
                                <div className="text-center">
                                    <div className={`text-4xl font-bold ${dashboardData.dailyCashFlow.netFlow >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                                        {dashboardData.dailyCashFlow.netFlow.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                    </div>
                                    <div className="text-lg text-gray-600">Net Nakit Akışı</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Profit Modal */}
            {showProfitModal && (
                <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-7xl max-h-[90vh] overflow-hidden flex flex-col">
                        <div className="px-6 py-4 border-b border-gray-200 bg-white">
                            <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
                                <div>
                                    <h2 className="text-2xl font-semibold text-gray-900 flex items-center gap-3">
                                        <Package className="w-7 h-7 text-green-600" />
                                        Kar Analizi
                                    </h2>
                                    <p className="text-sm text-gray-500 mt-1">
                                        {getDateRangeText()} dönemine ait ürün bazlı detaylı kar analizi ve performans raporu
                                    </p>
                                </div>
                                <div className="flex items-center gap-2">
                                    <button
                                        onClick={() => setShowProfitModal(false)}
                                        className="text-gray-400 hover:text-gray-600 transition-colors"
                                    >
                                        <X className="w-6 h-6" />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="flex-1 overflow-hidden bg-gray-50">
                            <div className="p-6 bg-white border-b border-gray-200">
                                <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                                    <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                        <div className="text-sm font-medium text-blue-600 mb-1">Toplam Kar</div>
                                        <div className="text-2xl font-bold text-blue-700">
                                            {dashboardData.productProfits?.totalProfit?.toLocaleString('tr-TR', { minimumFractionDigits: 2 }) || '0.00'} ₺
                                        </div>
                                    </div>
                                    <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                                        <div className="text-sm font-medium text-green-600 mb-1">Kar Marjı</div>
                                        <div className="text-2xl font-bold text-green-700">
                                            {`%${(dashboardData.productProfits?.profitMargin || 0).toFixed(1)}`}
                                        </div>
                                    </div>
                                    <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
                                        <div className="text-sm font-medium text-purple-600 mb-1">Toplam Ürün</div>
                                        <div className="text-2xl font-bold text-purple-700">
                                            {(dashboardData.productProfits?.products || []).length} adet
                                        </div>
                                    </div>
                                    <div className="bg-amber-50 p-4 rounded-lg border border-amber-200">
                                        <div className="text-sm font-medium text-amber-600 mb-1">Karlı Ürün</div>
                                        <div className="text-2xl font-bold text-amber-700">
                                            {(dashboardData.productProfits?.products || []).filter(p => (p.profit || 0) > 0).length} adet
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="overflow-x-auto overflow-y-auto max-h-[calc(90vh-300px)]">
                                <table className="min-w-full divide-y divide-gray-200">
                                    <thead className="bg-gray-100 sticky top-0 z-10">
                                        <tr>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Ürün Adı
                                            </th>
                                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Marka
                                            </th>
                                            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Stok
                                            </th>
                                            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Satılan
                                            </th>
                                            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Alış Fiyat
                                            </th>
                                            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Satış Fiyat
                                            </th>
                                            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Kar (₺)
                                            </th>
                                            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                Kar Marjı
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white divide-y divide-gray-200">
                                        {(dashboardData.productProfits?.products || []).length === 0 ? (
                                            <tr>
                                                <td colSpan="8" className="px-6 py-12 text-center">
                                                    <div className="flex flex-col items-center justify-center">
                                                        <Package className="h-16 w-16 mx-auto mb-4 text-gray-300" />
                                                        <p className="text-lg font-medium text-gray-900">Kar analizi bulunamadı</p>
                                                        <p className="text-sm text-gray-500 mt-1">
                                                            Seçili dönemde satış verisi bulunmamaktadır veya ürünlerin maliyet/satış fiyat bilgileri eksiktir.
                                                        </p>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : (
                                            (dashboardData.productProfits?.products || []).map((product, index) => {
                                                const costPrice = product.unitCost || 0;
                                                const salePrice = product.unitPrice || 0;
                                                const profit = product.profit || 0;
                                                const profitMargin = product.profitMargin || 0;
                                                return (
                                                    <tr key={product.id || index} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <div className="text-sm font-medium text-gray-900">{product.name}</div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <div className="text-sm text-gray-600">{product.brand || '-'}</div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-right">
                                                            <div className="text-sm font-semibold text-gray-900">{(product.stock || 0).toLocaleString('tr-TR')} adet</div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-right">
                                                            <div className="text-sm font-semibold text-gray-900">{(product.quantity || 0).toLocaleString('tr-TR')} adet</div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-right">
                                                            <div className="text-sm font-semibold text-gray-900">{costPrice.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-right">
                                                            <div className="text-sm font-semibold text-gray-900">{salePrice.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-right">
                                                            <div className={`text-sm font-bold ${profit >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                                                                {profit.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-right">
                                                            <div className={`text-sm font-bold ${profitMargin >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                                                                {profitMargin.toFixed(1)}%
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            )}


            {/* Cash Operations Modal (Income & Expense) */}
            {showCashIncomeModal && (
                <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 md:p-8">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-4xl max-h-[90vh] overflow-hidden flex flex-col">
                        <div className="px-8 py-6 border-b border-gray-200 bg-white">
                            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                                <div>
                                    <h2 className="text-2xl font-semibold text-gray-900 flex items-center gap-3">
                                        <ArrowUpRight className="w-7 h-7 text-green-600" />
                                        Kasa İşlemleri
                                    </h2>
                                    <p className="text-sm text-gray-500 mt-1">
                                        {getDateRangeText()} dönemine ait kasa gelir ve giderlerini yönetin.
                                    </p>
                                </div>
                                <button
                                    onClick={() => setShowCashIncomeModal(false)}
                                    className="self-start inline-flex items-center justify-center rounded-full border border-gray-200 bg-white p-2 text-gray-500 hover:text-gray-700 hover:border-gray-300 transition-colors"
                                    aria-label="Kapat"
                                    disabled={savingCashIncome}
                                >
                                    <X className="w-5 h-5" />
                                </button>
                            </div>
                        </div>

                        <div className="flex-1 overflow-y-auto bg-gray-50 px-6 py-6">
                            {cashIncomeModalLoading ? (
                                <div className="flex h-full items-center justify-center">
                                    <div className="flex flex-col items-center text-gray-500">
                                        <div className="h-10 w-10 animate-spin rounded-full border-b-2 border-green-500"></div>
                                        <span className="mt-3 text-sm">Kasa işlemleri yükleniyor...</span>
                                    </div>
                                </div>
                            ) : (
                                <div className="space-y-6">
                                    <section className="rounded-2xl border border-green-100 bg-white shadow-sm">
                                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 px-6 py-5 border-b border-green-100 bg-green-50">
                                            <div className="flex items-center gap-2">
                                                <ArrowUpRight className="w-5 h-5 text-green-600" />
                                                <h3 className="text-lg font-semibold text-green-900">Kasa Gelirleri</h3>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={addCashIncomeDraft}
                                                disabled={savingCashIncome}
                                                className="inline-flex items-center gap-2 rounded-lg bg-green-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-green-700 disabled:cursor-not-allowed disabled:opacity-60"
                                            >
                                                <Plus className="w-4 h-4" />
                                                Yeni Gelir
                                            </button>
                                        </div>
                                        <div className="px-6 py-5 space-y-4">
                                            {cashIncomeDraft.length === 0 ? (
                                                <div className="rounded-xl border border-dashed border-green-200 bg-green-50 py-10 text-center text-sm text-green-700">
                                                    Henüz gelir eklenmemiş. İlk kaydı ekleyin.
                                                </div>
                                            ) : (
                                                cashIncomeDraft.map((income, index) => (
                                                    <div key={income.tempId || income.id} className="rounded-xl border border-green-100 bg-white shadow-sm transition-shadow hover:shadow-md">
                                                        <div className="grid gap-4 md:grid-cols-[minmax(0,1fr)_180px_auto] items-start p-5">
                                                            <div className="space-y-2">
                                                                <label className="text-sm font-medium text-gray-700">Gelir Açıklaması</label>
                                                                <input
                                                                    type="text"
                                                                    value={income.description || ''}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (value.length <= 100) {
                                                                            handleCashIncomeDraftChange(income.tempId || income.id, 'description', value);
                                                                        }
                                                                    }}
                                                                    className="w-full rounded-lg border border-gray-300 px-4 py-3 text-base focus:border-green-500 focus:outline-none focus:ring-2 focus:ring-green-500"
                                                                    placeholder={`Gelir ${index + 1}`}
                                                                    maxLength={100}
                                                                />
                                                            </div>
                                                            <div className="space-y-2">
                                                                <label className="text-sm font-medium text-gray-700">Tutar (₺)</label>
                                                                <input
                                                                    type="number"
                                                                    step="0.01"
                                                                    min="0"
                                                                    value={income.amount === 0 ? 0 : income.amount || ''}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (value === '' || (!isNaN(value) && parseFloat(value) >= 0)) {
                                                                            handleCashIncomeDraftChange(income.tempId || income.id, 'amount', value);
                                                                        }
                                                                    }}
                                                                    className="w-full rounded-lg border border-gray-300 px-4 py-3 text-right text-base font-semibold focus:border-green-500 focus:outline-none focus:ring-2 focus:ring-green-500"
                                                                    placeholder="0.00"
                                                                />
                                                            </div>
                                                            <button
                                                                type="button"
                                                                onClick={() => removeCashIncomeDraft(income.tempId || income.id)}
                                                                className="inline-flex items-center justify-center gap-2 rounded-lg border border-red-200 px-4 py-3 text-sm font-medium text-red-600 transition-colors hover:border-red-300 hover:bg-red-50 hover:text-red-700"
                                                                disabled={savingCashIncome}
                                                                title="Bu geliri sil"
                                                            >
                                                                <X className="w-4 h-4" />
                                                                Sil
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                        <div className="flex items-center justify-between rounded-b-2xl border-t border-green-100 bg-green-50 px-6 py-4">
                                            <span className="text-sm font-medium text-gray-700">Toplam Gelir</span>
                                            <span className="text-xl font-semibold text-green-700">
                                                {getTotalAmount(cashIncomeDraft).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                            </span>
                                        </div>
                                    </section>

                                    <section className="rounded-2xl border border-red-100 bg-white shadow-sm">
                                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 px-6 py-5 border-b border-red-100 bg-red-50">
                                            <div className="flex items-center gap-2">
                                                <ArrowDownLeft className="w-5 h-5 text-red-600" />
                                                <h3 className="text-lg font-semibold text-red-900">Kasa Giderleri</h3>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={addCashExpenseDraft}
                                                disabled={savingCashExpenses}
                                                className="inline-flex items-center gap-2 rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60"
                                            >
                                                <Plus className="w-4 h-4" />
                                                Yeni Gider
                                            </button>
                                        </div>
                                        <div className="px-6 py-5 space-y-4">
                                            {cashExpenseDraft.length === 0 ? (
                                                <div className="rounded-xl border border-dashed border-red-200 bg-red-50 py-10 text-center text-sm text-red-700">
                                                    Henüz gider eklenmemiş. İlk kaydı ekleyin.
                                                </div>
                                            ) : (
                                                cashExpenseDraft.map((expense, index) => (
                                                    <div key={expense.tempId || expense.id} className="rounded-xl border border-red-100 bg-white shadow-sm transition-shadow hover:shadow-md">
                                                        <div className="grid gap-4 md:grid-cols-[minmax(0,1fr)_180px_auto] items-start p-5">
                                                            <div className="space-y-2">
                                                                <label className="text-sm font-medium text-gray-700">Gider Açıklaması</label>
                                                                <input
                                                                    type="text"
                                                                    value={expense.description || ''}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (value.length <= 100) {
                                                                            handleCashExpenseDraftChange(expense.tempId || expense.id, 'description', value);
                                                                        }
                                                                    }}
                                                                    className="w-full rounded-lg border border-gray-300 px-4 py-3 text-base focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500"
                                                                    placeholder={`Gider ${index + 1}`}
                                                                    maxLength={100}
                                                                />
                                                            </div>
                                                            <div className="space-y-2">
                                                                <label className="text-sm font-medium text-gray-700">Tutar (₺)</label>
                                                                <input
                                                                    type="number"
                                                                    step="0.01"
                                                                    min="0"
                                                                    value={expense.amount === 0 ? 0 : expense.amount || ''}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (value === '' || (!isNaN(value) && parseFloat(value) >= 0)) {
                                                                            handleCashExpenseDraftChange(expense.tempId || expense.id, 'amount', value);
                                                                        }
                                                                    }}
                                                                    className="w-full rounded-lg border border-gray-300 px-4 py-3 text-right text-base font-semibold focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500"
                                                                    placeholder="0.00"
                                                                />
                                                            </div>
                                                            <button
                                                                type="button"
                                                                onClick={() => removeCashExpenseDraft(expense.tempId || expense.id)}
                                                                className="inline-flex items-center justify-center gap-2 rounded-lg border border-red-200 px-4 py-3 text-sm font-medium text-red-600 transition-colors hover:border-red-300 hover:bg-red-50 hover:text-red-700"
                                                                disabled={savingCashExpenses}
                                                                title="Bu gideri sil"
                                                            >
                                                                <X className="w-4 h-4" />
                                                                Sil
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                        <div className="flex items-center justify-between rounded-b-2xl border-t border-red-100 bg-red-50 px-6 py-4">
                                            <span className="text-sm font-medium text-gray-700">Toplam Gider</span>
                                            <span className="text-xl font-semibold text-red-700">
                                                -{getTotalAmount(cashExpenseDraft).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                            </span>
                                        </div>
                                    </section>

                                    <section className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
                                        <h4 className="text-sm font-semibold text-gray-900">İpucu</h4>
                                        <p className="mt-2 text-sm text-gray-600">
                                            İşlemleri kaydetmeden önce açıklamaların dolu ve tutarların sıfırdan büyük olduğundan emin olun. Değişiklikler yalnızca <span className="font-medium text-gray-800">Kaydet</span> butonuyla uygulanır.
                                        </p>
                                    </section>
                                </div>
                            )}
                        </div>

                        <div className="px-8 py-5 border-t border-gray-200 bg-white">
                            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                                <div className="flex flex-wrap gap-6 text-sm text-gray-600">
                                    <span>
                                        <span className="font-medium text-gray-900">Toplam Gelir:</span> {getTotalAmount(cashIncomeDraft).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                    </span>
                                    <span>
                                        <span className="font-medium text-gray-900">Toplam Gider:</span> {getTotalAmount(cashExpenseDraft).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                    </span>
                                    <span>
                                        <span className="font-medium text-gray-900">Net:</span> {(getTotalAmount(cashIncomeDraft) - getTotalAmount(cashExpenseDraft)).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                    </span>
                                </div>
                                <div className="flex items-center gap-3">
                                    <button
                                        type="button"
                                        onClick={() => setShowCashIncomeModal(false)}
                                        disabled={savingCashIncome || savingCashExpenses}
                                        className="inline-flex items-center justify-center rounded-lg border border-gray-300 px-5 py-2.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-60"
                                    >
                                        Kapat
                                    </button>
                                    <button
                                        onClick={async () => {
                                            // Save each section independently
                                            if (cashIncomeDraft.length > 0 || cashIncomeRemoved.length > 0) {
                                                await handleSaveCashIncome();
                                            }
                                            if (cashExpenseDraft.length > 0 || cashExpenseRemoved.length > 0) {
                                                await handleSaveCashExpenses();
                                            }
                                            if (cashIncomeDraft.length === 0 && cashExpenseDraft.length === 0 && cashIncomeRemoved.length === 0 && cashExpenseRemoved.length === 0) {
                                                alert('Kaydedilecek veri bulunamadı. Lütfen gelir veya gider ekleyin.');
                                            }
                                        }}
                                        disabled={savingCashIncome || savingCashExpenses}
                                        className="inline-flex items-center justify-center rounded-lg bg-blue-600 px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
                                    >
                                        {(savingCashIncome || savingCashExpenses) ? 'Kaydediliyor...' : 'Kaydet'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Service Data Modal */}
            {showServiceDataModal && (
                <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 md:p-8">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-5xl max-h-[90vh] overflow-hidden flex flex-col">
                        <div className="px-8 py-6 border-b border-gray-200 bg-white">
                            <div className="flex flex-col md:flex-row md:items-start md:justify-between gap-4">
                                <div>
                                    <h2 className="text-2xl font-semibold text-gray-900 flex items-center gap-3">
                                        <Activity className="w-7 h-7 text-blue-600" />
                                        Servis Verisi Düzenle
                                    </h2>
                                    <p className="text-sm text-gray-500 mt-1">
                                        {getDateRangeText()} dönemindeki servis gelir ve giderlerini yönetin.
                                    </p>
                                </div>
                                <button
                                    type="button"
                                    onClick={() => setShowServiceDataModal(false)}
                                    className="self-start inline-flex items-center justify-center rounded-full border border-gray-200 bg-white p-2 text-gray-500 hover:text-gray-700 hover:border-gray-300 transition-colors"
                                    aria-label="Kapat"
                                >
                                    <X className="w-5 h-5" />
                                </button>
                            </div>
                        </div>

                        <div className="flex-1 overflow-y-auto bg-gray-50 px-6 py-6 lg:px-8">
                            <div className="flex flex-col lg:flex-row gap-8">
                                <div className="flex-1 space-y-8">
                                    <section className="rounded-2xl border border-green-100 bg-white shadow-sm">
                                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 px-6 py-5 border-b border-green-100 bg-green-50">
                                            <div className="flex items-center gap-2">
                                                <ArrowUpRight className="w-5 h-5 text-green-600" />
                                                <h3 className="text-lg font-semibold text-green-900">Gelirler</h3>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={() => addServiceDraftItem('income')}
                                                disabled={savingServiceForm}
                                                className="inline-flex items-center gap-2 rounded-lg bg-green-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-green-700 disabled:cursor-not-allowed disabled:opacity-60"
                                            >
                                                <Plus className="w-4 h-4" />
                                                Yeni Gelir
                                            </button>
                                        </div>
                                        <div className="px-6 py-5 space-y-4">
                                            {(serviceFormDraft.income || []).length === 0 ? (
                                                <div className="rounded-xl border border-dashed border-green-200 bg-green-50 py-10 text-center text-sm text-green-700">
                                                    Henüz gelir eklenmemiş. İlk kaydı ekleyin.
                                                </div>
                                            ) : (
                                                (serviceFormDraft.income || []).map((item, index) => (
                                                    <div key={item.id} className="rounded-xl border border-green-100 bg-white shadow-sm transition-shadow hover:shadow-md">
                                                        <div className="grid gap-4 md:grid-cols-[minmax(0,1fr)_180px_auto] items-start p-5">
                                                            <div className="space-y-2">
                                                                <label className="text-sm font-medium text-gray-700">Gelir Açıklaması</label>
                                                                <input
                                                                    type="text"
                                                                    value={item.name || ''}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (value.length <= 100) {
                                                                            handleServiceDraftChange('income', item.id, 'name', value);
                                                                        }
                                                                    }}
                                                                    className="w-full rounded-lg border border-gray-300 px-4 py-3 text-base focus:border-green-500 focus:outline-none focus:ring-2 focus:ring-green-500"
                                                                    placeholder={`Gelir ${index + 1}`}
                                                                    maxLength={100}
                                                                />
                                                            </div>
                                                            <div className="space-y-2">
                                                                <label className="text-sm font-medium text-gray-700">Tutar (₺)</label>
                                                                <input
                                                                    type="number"
                                                                    step="0.01"
                                                                    min="0"
                                                                    value={item.amount === 0 ? 0 : item.amount || ''}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (value === '' || (!isNaN(value) && parseFloat(value) >= 0)) {
                                                                            handleServiceDraftChange('income', item.id, 'amount', value);
                                                                        }
                                                                    }}
                                                                    className="w-full rounded-lg border border-gray-300 px-4 py-3 text-right text-base font-semibold focus:border-green-500 focus:outline-none focus:ring-2 focus:ring-green-500"
                                                                    placeholder="0.00"
                                                                />
                                                            </div>
                                                            <button
                                                                type="button"
                                                                onClick={() => removeServiceDraftItem('income', item.id)}
                                                                className="inline-flex items-center justify-center gap-2 rounded-lg border border-red-200 px-4 py-3 text-sm font-medium text-red-600 transition-colors hover:border-red-300 hover:bg-red-50 hover:text-red-700"
                                                                title="Bu geliri sil"
                                                            >
                                                                <X className="w-4 h-4" />
                                                                Sil
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                        <div className="flex items-center justify-between rounded-b-2xl border-t border-green-100 bg-green-50 px-6 py-4">
                                            <span className="text-sm font-medium text-gray-700">Toplam Gelir</span>
                                            <span className="text-xl font-semibold text-green-700">
                                                {getTotalAmount(serviceFormDraft.income || []).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                            </span>
                                        </div>
                                    </section>

                                    <section className="rounded-2xl border border-red-100 bg-white shadow-sm">
                                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 px-6 py-5 border-b border-red-100 bg-red-50">
                                            <div className="flex items-center gap-2">
                                                <ArrowDownRight className="w-5 h-5 text-red-600" />
                                                <h3 className="text-lg font-semibold text-red-900">Giderler</h3>
                                            </div>
                                            <button
                                                type="button"
                                                onClick={() => addServiceDraftItem('expenses')}
                                                disabled={savingServiceForm}
                                                className="inline-flex items-center gap-2 rounded-lg bg-red-600 px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-red-700 disabled:cursor-not-allowed disabled:opacity-60"
                                            >
                                                <Plus className="w-4 h-4" />
                                                Yeni Gider
                                            </button>
                                        </div>
                                        <div className="px-6 py-5 space-y-4">
                                            {(serviceFormDraft.expenses || []).length === 0 ? (
                                                <div className="rounded-xl border border-dashed border-red-200 bg-red-50 py-10 text-center text-sm text-red-700">
                                                    Henüz gider eklenmemiş. İlk kaydı ekleyin.
                                                </div>
                                            ) : (
                                                (serviceFormDraft.expenses || []).map((item, index) => (
                                                    <div key={item.id} className="rounded-xl border border-red-100 bg-white shadow-sm transition-shadow hover:shadow-md">
                                                        <div className="grid gap-4 md:grid-cols-[minmax(0,1fr)_180px_auto] items-start p-5">
                                                            <div className="space-y-2">
                                                                <label className="text-sm font-medium text-gray-700">Gider Açıklaması</label>
                                                                <input
                                                                    type="text"
                                                                    value={item.name || ''}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (value.length <= 100) {
                                                                            handleServiceDraftChange('expenses', item.id, 'name', value);
                                                                        }
                                                                    }}
                                                                    className="w-full rounded-lg border border-gray-300 px-4 py-3 text-base focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500"
                                                                    placeholder={`Gider ${index + 1}`}
                                                                    maxLength={100}
                                                                />
                                                            </div>
                                                            <div className="space-y-2">
                                                                <label className="text-sm font-medium text-gray-700">Tutar (₺)</label>
                                                                <input
                                                                    type="number"
                                                                    step="0.01"
                                                                    min="0"
                                                                    value={item.amount === 0 ? 0 : item.amount || ''}
                                                                    onChange={(e) => {
                                                                        const value = e.target.value;
                                                                        if (value === '' || (!isNaN(value) && parseFloat(value) >= 0)) {
                                                                            handleServiceDraftChange('expenses', item.id, 'amount', value);
                                                                        }
                                                                    }}
                                                                    className="w-full rounded-lg border border-gray-300 px-4 py-3 text-right text-base font-semibold focus:border-red-500 focus:outline-none focus:ring-2 focus:ring-red-500"
                                                                    placeholder="0.00"
                                                                />
                                                            </div>
                                                            <button
                                                                type="button"
                                                                onClick={() => removeServiceDraftItem('expenses', item.id)}
                                                                className="inline-flex items-center justify-center gap-2 rounded-lg border border-red-200 px-4 py-3 text-sm font-medium text-red-600 transition-colors hover:border-red-300 hover:bg-red-50 hover:text-red-700"
                                                                title="Bu gideri sil"
                                                            >
                                                                <X className="w-4 h-4" />
                                                                Sil
                                                            </button>
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                        <div className="flex items-center justify-between rounded-b-2xl border-t border-red-100 bg-red-50 px-6 py-4">
                                            <span className="text-sm font-medium text-gray-700">Toplam Gider</span>
                                            <span className="text-xl font-semibold text-red-700">
                                                {getTotalAmount(serviceFormDraft.expenses || []).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                            </span>
                                        </div>
                                    </section>
                                </div>

                                <aside className="w-full lg:w-80 space-y-5">
                                    <div className="rounded-2xl border border-blue-100 bg-white p-6 shadow-sm space-y-4">
                                        <div>
                                            <p className="text-xs font-semibold uppercase tracking-wide text-blue-600">Seçili Dönem</p>
                                            <p className="text-base font-medium text-gray-900 mt-1">{getDateRangeText()}</p>
                                        </div>
                                        <div className="space-y-3">
                                            <div className="flex items-center justify-between">
                                                <span className="text-sm text-gray-600">Toplam Gelir</span>
                                                <span className="text-lg font-semibold text-green-600">
                                                    {getTotalAmount(serviceFormDraft.income || []).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                </span>
                                            </div>
                                            <div className="flex items-center justify-between">
                                                <span className="text-sm text-gray-600">Toplam Gider</span>
                                                <span className="text-lg font-semibold text-red-600">
                                                    {getTotalAmount(serviceFormDraft.expenses || []).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                </span>
                                            </div>
                                            <div className="flex items-center justify-between">
                                                <span className="text-sm text-gray-600">Net Servis Akışı</span>
                                                <span className={`text-lg font-semibold ${getTotalAmount(serviceFormDraft.income || []) - getTotalAmount(serviceFormDraft.expenses || []) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                                                    {(getTotalAmount(serviceFormDraft.income || []) - getTotalAmount(serviceFormDraft.expenses || [])).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                </span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="rounded-2xl border border-gray-200 bg-white p-5 shadow-sm">
                                        <h4 className="text-sm font-semibold text-gray-900">İpucu</h4>
                                        <p className="mt-2 text-sm text-gray-600">
                                            Tüm değişiklikler sadece <span className="font-medium text-gray-800">Kaydet</span> butonuna bastığınızda uygulanır. Boş açıklama ya da geçersiz tutar içeren kayıtlar kaydedilmez.
                                        </p>
                                    </div>
                                </aside>
                            </div>
                        </div>

                        <div className="px-8 py-5 border-t border-gray-200 bg-white">
                            <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
                                <div className="flex flex-wrap gap-6 text-sm text-gray-600">
                                    <span>
                                        <span className="font-medium text-gray-900">Toplam Gelir:</span> {getTotalAmount(serviceFormDraft.income || []).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                    </span>
                                    <span>
                                        <span className="font-medium text-gray-900">Toplam Gider:</span> {getTotalAmount(serviceFormDraft.expenses || []).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                    </span>
                                    <span>
                                        <span className="font-medium text-gray-900">Net:</span> {(getTotalAmount(serviceFormDraft.income || []) - getTotalAmount(serviceFormDraft.expenses || [])).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                    </span>
                                </div>
                                <div className="flex items-center gap-3">
                                    <button
                                        type="button"
                                        onClick={() => setShowServiceDataModal(false)}
                                        disabled={savingServiceForm}
                                        className="inline-flex items-center justify-center rounded-lg border border-gray-300 px-5 py-2.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-100 disabled:cursor-not-allowed disabled:opacity-60"
                                    >
                                        Kapat
                                    </button>
                                    <button
                                        onClick={handleSaveServiceData}
                                        disabled={savingServiceForm}
                                        className="inline-flex items-center justify-center rounded-lg bg-blue-600 px-6 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-blue-700 disabled:cursor-not-allowed disabled:opacity-60"
                                    >
                                        {savingServiceForm ? 'Kaydediliyor...' : 'Kaydet'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Sold Quantity Modal */}
            {showSoldQuantityModal && (
                <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
                        <div className="px-6 py-4 border-b border-gray-200 bg-white">
                            <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
                                <div>
                                    <h2 className="text-2xl font-semibold text-gray-900 flex items-center gap-3">
                                        <Package className="w-7 h-7 text-green-600" />
                                        Satılan Ürünler
                                    </h2>
                                    <p className="text-sm text-gray-500 mt-1">
                                        Kasa satışlarında satılan ürünlerin detaylı raporu
                                    </p>
                                </div>
                                <div className="flex items-center gap-2">
                                    <button
                                        onClick={() => setShowSoldQuantityModal(false)}
                                        className="text-gray-400 hover:text-gray-600 transition-colors"
                                    >
                                        <X className="w-6 h-6" />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="flex-1 overflow-y-auto bg-gray-50">
                            {loadingSoldProducts ? (
                                <div className="flex h-full items-center justify-center">
                                    <div className="flex flex-col items-center text-gray-500">
                                        <div className="h-10 w-10 animate-spin rounded-full border-b-2 border-green-500"></div>
                                        <span className="mt-3 text-sm">Satılan ürünler yükleniyor...</span>
                                    </div>
                                </div>
                            ) : soldProducts.length === 0 ? (
                                <div className="flex h-full items-center justify-center">
                                    <div className="text-center py-12 text-gray-500">
                                        <Package className="h-16 w-16 mx-auto mb-4 text-gray-300" />
                                        <p className="text-lg font-medium">Satılan ürün bulunamadı</p>
                                        <p className="text-sm mt-1">Bu dönemde kasa satışında ürün satışı yapılmamış.</p>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className="overflow-x-auto">
                                        <table className="min-w-full divide-y divide-gray-200">
                                            <thead className="bg-gray-100">
                                                <tr>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Ürün Adı
                                                    </th>
                                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Miktar (adet)
                                                    </th>
                                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Birim Fiyat (₺)
                                                    </th>
                                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Toplam Tutar (₺)
                                                    </th>
                                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Kar (₺)
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                                {soldProducts.map((product, index) => {
                                                    const unitPrice = product.price || 0;
                                                    const unitCost = product.cost || 0;
                                                    const totalPrice = (product.quantity || 0) * unitPrice;
                                                    const unitProfit = unitPrice - unitCost;
                                                    const totalProfit = unitProfit * (product.quantity || 0);
                                                    return (
                                                        <tr key={`${product.id}-${index}`} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                                            <td className="px-6 py-4 whitespace-nowrap">
                                                                <div className="text-sm font-medium text-gray-900">{product.name}</div>
                                                            </td>
                                                            <td className="px-6 py-4 whitespace-nowrap text-right">
                                                                <div className="text-sm font-semibold text-gray-900">{product.quantity?.toLocaleString('tr-TR')} adet</div>
                                                            </td>
                                                            <td className="px-6 py-4 whitespace-nowrap text-right">
                                                                <div className="text-sm font-semibold text-gray-900">{unitPrice.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</div>
                                                            </td>
                                                            <td className="px-6 py-4 whitespace-nowrap text-right">
                                                                <div className="text-sm font-bold text-green-600">{totalPrice.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺</div>
                                                            </td>
                                                            <td className="px-6 py-4 whitespace-nowrap text-right">
                                                                <div className={`text-sm font-bold ${totalProfit >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                                                                    {totalProfit.toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    );
                                                })}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Özet Kartı */}
                                    <div className="p-6 bg-white border-t border-gray-200">
                                        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                                            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                                <div className="text-sm font-medium text-blue-600 mb-1">Toplam Ürün Çeşidi</div>
                                                <div className="text-2xl font-bold text-blue-700">{soldProducts.length}</div>
                                            </div>
                                            <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                                                <div className="text-sm font-medium text-green-600 mb-1">Toplam Satış Adedi</div>
                                                <div className="text-2xl font-bold text-green-700">
                                                    {soldProducts.reduce((sum, p) => sum + (p.quantity || 0), 0).toLocaleString('tr-TR')} adet
                                                </div>
                                            </div>
                                            <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
                                                <div className="text-sm font-medium text-purple-600 mb-1">Toplam Gelir</div>
                                                <div className="text-2xl font-bold text-purple-700">
                                                    {soldProducts.reduce((sum, p) => sum + ((p.quantity || 0) * (p.price || 0)), 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                </div>
                                            </div>
                                            <div className={`${soldProducts.reduce((sum, p) => sum + ((p.quantity || 0) * ((p.price || 0) - (p.cost || 0))), 0) >= 0 ? 'bg-emerald-50 border-emerald-200' : 'bg-red-50 border-red-200'} p-4 rounded-lg border`}>
                                                <div className={`text-sm font-medium ${soldProducts.reduce((sum, p) => sum + ((p.quantity || 0) * ((p.price || 0) - (p.cost || 0))), 0) >= 0 ? 'text-emerald-600' : 'text-red-600'} mb-1`}>Toplam Kar</div>
                                                <div className={`text-2xl font-bold ${soldProducts.reduce((sum, p) => sum + ((p.quantity || 0) * ((p.price || 0) - (p.cost || 0))), 0) >= 0 ? 'text-emerald-700' : 'text-red-700'}`}>
                                                    {soldProducts.reduce((sum, p) => sum + ((p.quantity || 0) * ((p.price || 0) - (p.cost || 0))), 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* Car Sold Quantity Modal */}
            {showCarSoldQuantityModal && (
                <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-6xl max-h-[90vh] overflow-hidden flex flex-col">
                        <div className="px-6 py-4 border-b border-gray-200 bg-white">
                            <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
                                <div>
                                    <h2 className="text-2xl font-semibold text-gray-900 flex items-center gap-3">
                                        <Package className="w-7 h-7 text-blue-600" />
                                        Araç Satış Ürünleri
                                    </h2>
                                    <p className="text-sm text-gray-500 mt-1">
                                        Araç satışlarında satılan ürünlerin detaylı raporu
                                    </p>
                                </div>
                                <div className="flex items-center gap-2">
                                    <button
                                        onClick={() => setShowCarSoldQuantityModal(false)}
                                        className="text-gray-400 hover:text-gray-600 transition-colors"
                                    >
                                        <X className="w-6 h-6" />
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="flex-1 overflow-y-auto bg-gray-50">
                            {loadingCarSoldProducts ? (
                                <div className="flex h-full items-center justify-center">
                                    <div className="flex flex-col items-center text-gray-500">
                                        <div className="h-10 w-10 animate-spin rounded-full border-b-2 border-blue-500"></div>
                                        <span className="mt-3 text-sm">Araç satış ürünleri yükleniyor...</span>
                                    </div>
                                </div>
                            ) : carSoldProducts.length === 0 ? (
                                <div className="flex h-full items-center justify-center">
                                    <div className="text-center py-12 text-gray-500">
                                        <Package className="h-16 w-16 mx-auto mb-4 text-gray-300" />
                                        <p className="text-lg font-medium">Araç satış ürünü bulunamadı</p>
                                        <p className="text-sm mt-1">Bu dönemde araç satışında ürün satışı yapılmamış.</p>
                                    </div>
                                </div>
                            ) : (
                                <>
                                    <div className="overflow-x-auto">
                                        <table className="min-w-full divide-y divide-gray-200">
                                            <thead className="bg-gray-100">
                                                <tr>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Ürün Adı
                                                    </th>
                                                    <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Araç Plakası
                                                    </th>
                                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Miktar (adet)
                                                    </th>
                                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Birim Fiyat (₺)
                                                    </th>
                                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Toplam Tutar (₺)
                                                    </th>
                                                    <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                                                        Kar (₺)
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody className="bg-white divide-y divide-gray-200">
                                                {carSoldProducts.map((item, index) => (
                                                    <tr key={`${item.productId}-${item.carId}-${index}`} className={index % 2 === 0 ? 'bg-white' : 'bg-gray-50'}>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <div className="text-sm font-medium text-gray-900">{item.productName}</div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap">
                                                            <span className="px-3 py-1 bg-blue-100 text-blue-800 rounded-full text-sm font-medium">
                                                                {item.carPlate}
                                                            </span>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-right">
                                                            <div className="text-sm font-semibold text-gray-900">
                                                                {item.quantity?.toLocaleString('tr-TR')} adet
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-right">
                                                            <div className="text-sm font-semibold text-gray-900">
                                                                {(item.price || 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-right">
                                                            <div className="text-sm font-bold text-green-600">
                                                                {((item.quantity || 0) * (item.price || 0)).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                            </div>
                                                        </td>
                                                        <td className="px-6 py-4 whitespace-nowrap text-right">
                                                            <div className={`text-sm font-bold ${((item.quantity || 0) * ((item.price || 0) - (item.cost || 0))) >= 0 ? 'text-green-600' : 'text-red-600'}`}>
                                                                {((item.quantity || 0) * ((item.price || 0) - (item.cost || 0))).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Özet Kartı */}
                                    <div className="p-6 bg-white border-t border-gray-200">
                                        <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
                                            <div className="bg-blue-50 p-4 rounded-lg border border-blue-200">
                                                <div className="text-sm font-medium text-blue-600 mb-1">Toplam Ürün Çeşidi</div>
                                                <div className="text-2xl font-bold text-blue-700">
                                                    {new Set(carSoldProducts.map(item => item.productId)).size}
                                                </div>
                                            </div>
                                            <div className="bg-green-50 p-4 rounded-lg border border-green-200">
                                                <div className="text-sm font-medium text-green-600 mb-1">Toplam Satış Adedi</div>
                                                <div className="text-2xl font-bold text-green-700">
                                                    {carSoldProducts.reduce((sum, item) => sum + (item.quantity || 0), 0).toLocaleString('tr-TR')} adet
                                                </div>
                                            </div>
                                            <div className="bg-purple-50 p-4 rounded-lg border border-purple-200">
                                                <div className="text-sm font-medium text-purple-600 mb-1">Toplam Gelir</div>
                                                <div className="text-2xl font-bold text-purple-700">
                                                    {carSoldProducts.reduce((sum, item) => sum + ((item.quantity || 0) * (item.price || 0)), 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                </div>
                                            </div>
                                            <div className={`${carSoldProducts.reduce((sum, item) => sum + ((item.quantity || 0) * ((item.price || 0) - (item.cost || 0))), 0) >= 0 ? 'bg-emerald-50 border-emerald-200' : 'bg-red-50 border-red-200'} p-4 rounded-lg border`}>
                                                <div className={`text-sm font-medium ${carSoldProducts.reduce((sum, item) => sum + ((item.quantity || 0) * ((item.price || 0) - (item.cost || 0))), 0) >= 0 ? 'text-emerald-600' : 'text-red-600'} mb-1`}>Toplam Kar</div>
                                                <div className={`text-2xl font-bold ${carSoldProducts.reduce((sum, item) => sum + ((item.quantity || 0) * ((item.price || 0) - (item.cost || 0))), 0) >= 0 ? 'text-emerald-700' : 'text-red-700'}`}>
                                                    {carSoldProducts.reduce((sum, item) => sum + ((item.quantity || 0) * ((item.price || 0) - (item.cost || 0))), 0).toLocaleString('tr-TR', { minimumFractionDigits: 2 })} ₺
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};

export default DashboardModals;
